import { Star } from "lucide-react";

interface TestimonialCardProps {
  quote: string;
  name: string;
  title: string;
  rating: number;
  service: string;
  location: string;
}

const TestimonialCard = ({ quote, name, title, rating, service, location }: TestimonialCardProps) => {
  const filled = Math.floor(rating);

  return (
    <div className="surface-card flex h-full flex-col p-8">
      {/* Star rating */}
      <div className="mb-4 flex gap-0.5" aria-label={`${rating} out of 5 stars`}>
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            strokeWidth={2}
            className={`h-5 w-5 ${i < filled ? "fill-primary text-primary" : "fill-muted text-muted"}`}
          />
        ))}
      </div>
      <h3 className="mb-3 font-heading text-lg uppercase text-navy">{title}</h3>
      {/* Quote */}
      <p className="mb-6 flex-grow leading-relaxed text-charcoal">
        "{quote}"
      </p>
      <div className="mt-auto border-t border-border pt-4">
        <p className="font-semibold text-charcoal">{name}</p>
        <p className="text-sm text-muted-foreground">{location}</p>
        <p className="mt-1 text-sm font-medium text-primary">{service}</p>
      </div>
    </div>
  );
};

export default TestimonialCard;
